var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.937,
    height: 29.483,
    "data-name": "Group 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3364fb",
    d: "M33.936 1.221c-.332 1.061-.67 2.12-.995 3.183q-3.545 11.609-7.086 23.22a1.015 1.015 0 0 1-1.737.571q-4.31-3.2-8.617-6.395c-.088-.065-.178-.127-.294-.209-.063.119-.119.222-.172.326q-1.728 3.427-3.453 6.855a1.1 1.1 0 0 1-.817.7.985.985 0 0 1-1.151-.91c-.009-.11 0-.221 0-.331q0-5.152.006-10.3a.42.42 0 0 0-.323-.475Q5.049 15.833.811 14.184c-.555-.215-.814-.538-.807-1.006a1.036 1.036 0 0 1 .8-.974L32.442.122c.7-.266 1.125-.082 1.495.642Zm-3.232 3.694-.068-.047-14.294 15.079 7.973 5.916Zm-4.9-.066-.043-.054-21.973 8.388c.157.069.255.117.356.156 2 .771 3.992 1.536 5.984 2.317a.58.58 0 0 0 .63-.082q6.077-4.343 12.164-8.67ZM11.595 24.155l.062.016.151-.282c.691-1.368 1.378-2.738 2.076-4.1a2.2 2.2 0 0 1 .359-.509q5.212-5.511 10.431-11.015c.075-.079.145-.165.217-.247a.9.9 0 0 0-.332.163l-5.015 3.573q-3.856 2.746-7.708 5.5a.54.54 0 0 0-.229.349c-.012 2.181-.009 4.367-.009 6.553Z",
    "data-name": "Path 55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.942cc939a62e6c61db6cbd021267979f.svg";
export { ForwardRef as ReactComponent };